import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useNumTerminals() {
	const location = useLocation();

	const numTerminals = useMemo(() => {
		const query = new URLSearchParams(location.search);
		let numTerminals = query.get('terminals') ?? 1;

		if (numTerminals < 0) {
			numTerminals = 1; // Ensure at least one terminal
		}

		return numTerminals - 1; // Subtract 1 to account for the main terminal
	}, [location]);

	return numTerminals;
}
